import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Select, MenuItem, FormControl, InputLabel, Typography, TextField
} from "@mui/material";
import { AlertType } from 'mdui/page/MsgBox';
import { useUtil } from "mdui/page/UtilProvider";
import { post } from "mdui/api/HttpReq";

export default function SelectWithDialog({ open, onClose, cmdList, process, envId }) {
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedCmd, setSelectedCmd] = useState(null);
  const [argsDialogOpen, setArgsDialogOpen] = useState(false);
  const [argsValue, setArgsValue] = useState("");
   const { openModel } = useUtil();

  const options = cmdList || [];

  const handleSelectChange = (event) => {
    const cmd = options.find(o => o.cmd === event.target.value);
    setSelectedValue(event.target.value);
    setSelectedCmd(cmd);

    if (cmd?.allowArgs === "Y") {
      setArgsDialogOpen(true);
    }
  };

  const handleExecute = () => {
    //alert(`Executing ${selectedValue} for ${process.processName} with args: ${argsValue || "N/A"}`);
    	async function runJob() {
			
			const payload = {
				proc: process?.processId ?? process?.processName,
				mgr: process.mgrName,
				env: envId,
				param: argsValue, // value from popup
				cmd: selectedValue
			};
				try {
					const resp = await post("execCmd", "list", payload);
					 const data = typeof resp === "string" ? JSON.parse(resp) : resp;
					console.log("val", data);

					if (data && data.result === true) {
						let msg = 'Command ' + selectedValue + ' executed successfully';
					openModel({ msg: msg, type: AlertType.S });
					} else {
						let msg = 'Command ' + selectedValue + ' execution failed';
						openModel({ msg: msg, type: AlertType.E });
					}
				} catch (error) {
					console.error("Failed to load job data", error);
					openModel({ msg: "load_error", type: AlertType.E });
				}
			}

			runJob(); // call the async function
    onClose();
  };

  const handleArgsCancel = () => {
    setArgsDialogOpen(false);
    setSelectedValue(""); // reset if they cancel
    setSelectedCmd(null);
  };

  const handleArgsOk = () => {
	  handleExecute();
    setArgsDialogOpen(false);
  };

  return (
    <>
      {/* Main Dialog */}
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Process Information : {process?.processId ?? process?.processName}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel>Command</InputLabel>
            <Select value={selectedValue} onChange={handleSelectChange}>
              <MenuItem value="">Select Command</MenuItem>
              {options.map((option) => (
                <MenuItem key={option.cmd} value={option.cmd}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="info" variant="contained">Cancel</Button>
          <Button
            onClick={handleExecute}
            color="primary"
            variant="contained"
            disabled={!selectedValue}
          >
            Execute
          </Button>
        </DialogActions>
      </Dialog>

      {/* Arguments Dialog */}
      <Dialog open={argsDialogOpen} onClose={handleArgsCancel} maxWidth="sm" fullWidth>
        <DialogTitle>
          Enter Command Arguments for [{selectedCmd?.text}]
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            [{selectedCmd?.text}] supports input parameters.
          </Typography>
          <Typography gutterBottom>
            Do you wish to enter any parameters?
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            You may leave blank and press 'OK' for default parameters to be sent.
            Pressing 'Cancel' will prevent [{selectedCmd?.text}] from being sent.
          </Typography>
          <Typography variant="body2" paragraph>
            <strong>Example:</strong> key1='Value1';key2='Value2';key3='Value3';
          </Typography>
          <TextField
            fullWidth
            value={argsValue}
            onChange={(e) => setArgsValue(e.target.value)}
            placeholder="Enter parameters here..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleArgsCancel} variant="contained" color="info">
            Cancel
          </Button>
          <Button onClick={handleArgsOk} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
